import { buildFormatLongFn } from "../../_lib/buildFormatLongFn.js";
var dateFormats = {
  full: "EEEE, MMMM do, y",
  "long": "MMMM do, y",
  medium: "MMM d, y",
  "short": "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  "long": "h:mm:ss a z",
  medium: "h:mm:ss a",
  "short": "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  "long": "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  "short": "{{date}}, {{time}}"
};
export var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};